// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { metis as _metis } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the metis chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1088
 * Chain Name: Metis
 * Default Block Explorer: https://explorer.metis.io
 * Default RPC URL: https://andromeda.metis.io/?owner=1088
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { metis } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: metis,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const metis = createCommon({
	..._metis,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
